import React from "react";

import { MenuItem, Select } from "@mui/material";
import { CurrencyType } from "store/types";

import { currenciesArray } from "../../../constants";

interface SelectCurrencyProps {
  currency: CurrencyType;
  onChange: (currency: CurrencyType) => void;
  disabled?: boolean; //flag of permission restriction
}

export const SelectCurrency: React.FC<SelectCurrencyProps> = ({ currency, onChange, disabled }) => {
  return (
    <Select
      disabled={disabled}
      sx={{
        width: "100px",
        borderRadius: "20px",
        fontSize: "16px",
        backgroundColor: "#ffffff",
        "& .MuiSelect-select": {
          padding: "0 10px !important"
        }
      }}
      value={currency || "USD"}
      onChange={(event) => {
        onChange(event.target.value as CurrencyType);
      }}
    >
      {currenciesArray.map((currency) => (
        <MenuItem key={currency} value={currency}>
          {currency}
        </MenuItem>
      ))}
    </Select>
  );
};
